import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
const Landing = () =>
  import(/* webpackChunkName: "landing" */ "./components/Landing.vue");
const Main = () =>
  import(/* webpackChunkName: "main" */ "./components/Main.vue");
const List = () =>
  import(/* webpackChunkName: "list" */ "./components/List.vue");
const Detail = () =>
  import(/* webpackChunkName: "detail" */ "./components/Detail.vue");

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "landing",
      component: Landing
  },
  {
      path: "/main",
      name: "main",
      component: Main
  },
  {
      path: "/list",
      name: "list",
      component: List
  },
  {
      path: "/project:prjIdx",
      name: "detail",
      component: Detail,
      props: true
  },
  {
      path: "*",
      redirect: "/"
  }
  ]
})
